<template>

  <div class="page-margin">

    <div class="breadcrumb-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6 d-align-center">
            <h2 class="title"><span> Blog</span></h2>
          </div>
          <div class="col-md-6 col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb bg-transparent mb-0">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Index' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">
                  <a href="#">Blog details with right-sidebar</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <section class="blog-page">
      <div class="container">
        <div class="row">

          <div class="col-sm-12 col-md-8 col-lg-9">
            <div class="blog-details news-slid">
              <div class="news-box">
                <img
                  src="../assets/images/blog/1.jpg"
                  alt="news-1"
                  class="img-fluid"
                />
              </div>
              <div class="news-text">
                <div class="blog-hover">
                  <h4>
                    There are many variations of passages of Lorem Ipsum
                    available
                  </h4>
                  <ul class="list-inline blog-details-list">
                    <li><a href="#">John Doe</a></li>
                    <li><a href="#">1 Oct</a></li>
                    <li><a href="#">25 comments</a></li>
                    <li><a href="#">3 View</a></li>
                  </ul>
                </div>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
              </div>
            </div>
            <div class="blog-divider"></div>
            <div class="reply-comment">
              <div class="media">
                <img
                  class="align-self-top mr-3"
                  src="../assets/images/blog/blog-comment.jpg"
                  alt="blog"
                />
                <div class="media-body">
                  <a href="#">
                    <h5 class="mt-0">Lorem Ipsum Is Simply Dummy</h5>
                  </a>
                  <p>
                    Cras sit amet nibh libero, in gravida nulla. Nulla vel metus
                    scelerisque ante sollicitudin. Cras purus odio, vestibulum
                    in vulputate at, tempus viverra turpis. Fusce condimentum
                    nunc ac nisi vulputate fringilla. Donec lacinia congue felis
                    in faucibus.Donec sed odio dui.
                  </p>
                </div>
              </div>
              <div class="media">
                <img
                  class="align-self-top mr-3"
                  src="../assets/images/blog/blog-comment-two.jpg"
                  alt="blog"
                />
                <div class="media-body">
                  <a href="#">
                    <h5 class="mt-0">Lorem Ipsum has been the</h5>
                  </a>
                  <p>
                    Cras sit amet nibh libero, in gravida nulla. Nulla vel metus
                    scelerisque ante sollicitudin. Cras purus odio, vestibulum
                    in vulputate at, tempus viverra turpis. Fusce condimentum
                    nunc ac nisi vulputate fringilla. Donec lacinia congue felis
                    in faucibus.Donec sed odio dui.
                  </p>
                </div>
              </div>
              <div class="media">
                <img
                  class="align-self-top mr-3"
                  src="../assets/images/blog/blog-comment-three.jpg"
                  alt="blog"
                />
                <div class="media-body">
                  <a href="#">
                    <h5 class="mt-0">all the Lorem Ipsum Generator</h5>
                  </a>
                  <p>
                    Cras sit amet nibh libero, in gravida nulla. Nulla vel metus
                    scelerisque ante sollicitudin. Cras purus odio, vestibulum
                    in vulputate at, tempus viverra turpis. Fusce condimentum
                    nunc ac nisi vulputate fringilla. Donec lacinia congue felis
                    in faucibus.
                  </p>
                </div>
              </div>
            </div>
            <div class="blog-divider"></div>
            <div class="row">
              <div class="col-md-10 offset-md-1 leave-coment">
                <h3 class="text-center">Leave Your Comment</h3>
                <form class="theme-form p-0 mt-3">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-lg-6 col-md-12 md-fgrup-margin">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="your name"
                        />
                      </div>
                      <div class="col-lg-6 col-md-12">
                        <input
                          type="email"
                          class="form-control"
                          id="exampleFormControlInput1"
                          placeholder="email address"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="4"
                      placeholder="message"
                    ></textarea>
                  </div>
                  <div class="form-button">
                    <button type="submit" class="btn btn-theme theme-color">
                      send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-lg-3 order-md-last list-sidebar">
            <div class="sidebar">
              <div class="sidebar-space">
                <h4 class="blog-title">blog Category</h4>
                <div class="blog-divider"></div>
                <div class="blog-cat-detail">
                  <ul>
                    <li class="marg-15">
                      <router-link :to="{ name: 'Blogdetails' }">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        Lorem Ipsum is simply
                      </router-link>
                    </li>
                    <li class="marg-15">
                      <router-link :to="{ name: 'Blogdetails' }">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        There Are Many Variations
                      </router-link>
                    </li>
                    <li class="marg-15">
                      <router-link :to="{ name: 'Blogdetails' }">
                        <i class="fa fa-angle-right" aria-hidden="true"></i> it
                        has survived not five
                      </router-link>
                    </li>
                    <li class="marg-15">
                      <router-link :to="{ name: 'Blogdetails' }">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        Lorem Ipsum has been the.
                      </router-link>
                    </li>
                    <li class="marg-15">
                      <router-link :to="{ name: 'Blogdetails' }">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        Lorem Ipsum is random.
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="sidebar-space">
                <h4 class="blog-title">Popular Tag</h4>
                <div class="blog-divider"></div>
                <div class="tags marg-20">
                  <a href="#"
                    ><span class="badge badge-theme">Responsive design</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">Color options</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">Multiple demos</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">Dedicated support</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">Documentation</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">PSD is included</span></a
                  >
                  <a href="#"><span class="badge badge-theme">Text</span></a>
                  <a href="#"><span class="badge badge-theme">Support</span></a>
                  <a href="#"
                    ><span class="badge badge-theme">Responsive</span></a
                  >
                  <a href="#"><span class="badge badge-theme">Design</span></a>
                </div>
              </div>
              <h4 class="blog-title">Recent Post</h4>
              <div class="blog-divider"></div>
              <div class="recent-blog marg-20">
                <div class="media">
                  <img
                    class="mr-3"
                    src="../assets/images/blog/blog-comment-two.jpg"
                    alt="blog"
                  />
                  <div class="media-body">
                    <router-link :to="{ name: 'Blogdetails' }">
                      <h5 class="mt-0">Lorem Ipsum Is Simply Dummy</h5>
                    </router-link>
                    <p class="m-0">05 March 2011</p>
                  </div>
                </div>
                <div class="media">
                  <img
                    class="mr-3"
                    src="../assets/images/blog/blog-comment-three.jpg"
                    alt="blog"
                  />
                  <div class="media-body">
                    <router-link :to="{ name: 'Blogdetails' }">
                      <h5 class="mt-0">Lorem Ipsum Is Simply Dummy</h5>
                    </router-link>
                    <p class="m-0">05 March 2011</p>
                  </div>
                </div>
                <div class="media">
                  <img
                    class="mr-3"
                    src="../assets/images/blog/blog-comment.jpg"
                    alt="blog"
                  />
                  <div class="media-body">
                    <router-link :to="{ name: 'Blogdetails' }">
                      <h5 class="mt-0">Lorem Ipsum Is Simply Dummy</h5>
                    </router-link>
                    <p class="m-0">05 March 2011</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
 
        </div>
      </div>
    </section>
  
    <Copyright />

  </div>

</template>
<script>
import Copyright from "@/components/copy_right.vue";

export default {
  name: "Blogdetails",
  components: {
    Copyright
  },
  beforeCreate: function () {
    const path = this.$route.path; 
    if (path === "/chatloop/rtl/blog-details-with-right-sidebar") {
      document.body.className = "inner-page rtl";
    } else {
      document.body.className = "inner-page";
    }
  },
};
</script>
